/**
 * @fileoverview Barrel exports for the chapter-drafter-enhanced-v2 COMPOSITE agent.
 *
 * This is a composite agent that orchestrates two primitives in a pipeline:
 * - chapter-drafter-v2: Generates initial chapter draft
 * - draft-refiner-v2: Refines and improves the draft
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Pipeline orchestration logic using executePipeline
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  type Input,
  type Output,
  type HookInput,
} from './schema';

// Flow
export { flow, chapterDrafterEnhancedV2AgentFlow } from './flow';

